module.exports = __webpack_public_path__ + "static/media/baomingBtn.png";